/**
 * @flow
 * @relayHash f5b3552a8cb9e137f25e8a666c883a28
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PostCreateQueryVariables = {||};
export type PostCreateQueryResponse = {|
  +viewer: ?{|
    +id: string
  |}
|};
export type PostCreateQuery = {|
  variables: PostCreateQueryVariables,
  response: PostCreateQueryResponse,
|};
*/


/*
query PostCreateQuery {
  viewer {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "Query",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PostCreateQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "PostCreateQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "PostCreateQuery",
    "id": null,
    "text": "query PostCreateQuery {\n  viewer {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5548aa4dac8938f0ac00504abbe7c151';
module.exports = node;
